import Session from 'supertokens-auth-react/recipe/session'

import getCookieHandler from './cookieHandler'

export const frontendConfig = () => {
  const appInfo = {
    appName: 'Patient Hub',
    apiDomain: import.meta.env.VITE_WEBSITE_DOMAIN,
    websiteDomain: import.meta.env.VITE_WEBSITE_DOMAIN,
    apiBasePath: '/auth',
    websiteBasePath: '/auth',
  }

  return {
    cookieHandler: getCookieHandler,
    appInfo,
    recipeList: [
      Session.init({
        tokenTransferMethod: 'cookie',
      }),
    ],
  }
}
